import { faFileText, faClose } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BarLoader } from "react-spinners";
import { ChatDocument } from "app/modules/aiAssistant/AIAssistantSlice";
import "app/modules/aiAssistant/styles/shared.scss";
import "./DocumentChips.scss";

type Props = {
  documents: ChatDocument[];
  uploadingDocumentIDs?: string[];
  // Read-only without it
  onRemove?: (file: ChatDocument) => void;
  getRemoveButtonTestId?: (documentID: string) => string;
};

const DocumentChips = ({ documents, uploadingDocumentIDs, onRemove, getRemoveButtonTestId }: Props) => {
  if (!documents.length) return null;

  return (
    <div className="assistimo-documents">
      {documents.map((file) => {
        const isUploading = uploadingDocumentIDs?.includes(file.id) ?? false;

        return (
          <div key={file.id} className="assistimo-document">
            <div className="assistimo-document__row">
              <FontAwesomeIcon icon={faFileText} className="assistimo-document__icon" />
              <span className="assistimo-document__name" title={file.name}>
                {file.name}
              </span>
              {onRemove && !isUploading && (
                <button
                  data-test-id={getRemoveButtonTestId?.(file.id)}
                  type="button"
                  className="assistimo-icon-button assistimo-icon-button--small"
                  aria-label={`Remove ${file.name}`}
                  onClick={() => onRemove(file)}
                >
                  <FontAwesomeIcon icon={faClose} />
                </button>
              )}
            </div>
            {isUploading && <BarLoader width="100%" height={2} color="currentColor" className="assistimo-spinner" />}
          </div>
        );
      })}
    </div>
  );
};

export default DocumentChips;
